export default {
  enabled: true,
  ip: "127.0.0.1",
  port: 9000,
  interval: 1000,
  instanceNumber: "0",
  fpsNum: 25,
  fpsDen: 1,
};
